import React, { lazy } from 'react'
import { Router, Switch, Redirect } from 'react-router-dom'
import history from './routerHistory'

import GlobalStyle from './style/Global'
import PageLoader from './components/PageLoader'
import SuspenseWithChunkError from './components/SuspenseWithChunkError'
import 'bootstrap/dist/css/bootstrap.min.css';
import './fonts/Montserrat/Montserrat.css'
import './fonts/inter/style.css'
import ScrollToTop from 'components/ScrollToTop'
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { ProtectedRoute, PublicRoute } from 'router'
import { useFetchPublicData, useUser } from 'state/hooks'

const Dashboard = lazy(() => import('views/Dashboard'))

const AssetOverview = lazy(() => import('./views/AssetOverview'))
const AssetCapital = lazy(() => import('./views/AssetCapital'))
const AssetOverviewDetail = lazy(() => import('./views/AssetOverviewDetail'))
const Login = lazy(() => import('./views/Login'))
const Forgot = lazy(() => import('./views/Forgot'))
const DataRoom = lazy(() => import('./views/DataRoom'))
const ResetPassword = lazy(() => import('./views/ResetPassword'))
const Menu = lazy(() => import('components/Menu'))
const MarketInsights = lazy(() => import('./views/Lookers/MarketInsights'))
const PortfolioReporting = lazy(() => import('./views/Lookers/PortfolioReporting'))
const AssetStrategy = lazy(() => import('./views/Lookers/AssetStrategy'))
const Top7Cities = lazy(() => import('./views/Lookers/Top7Cities'))
const DistrictComparativeAnalysis = lazy(() => import('./views/Lookers/DistrictComparativeAnalysis'))

const AssetReport = lazy(() => import('./views/Lookers/AssetReport'))
const App: React.FC = () => {


  useFetchPublicData()

  const user = useUser()

  return (
    <Router history={history}>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        />
      <ScrollToTop />
      <GlobalStyle />
      <SuspenseWithChunkError fallback={<PageLoader />}>
        

          <Switch>
            <PublicRoute path="/" exact component={Login} />

            <PublicRoute path="/login" exact component={Login} />

            <PublicRoute path="/forgot-password" exact component={Forgot} />

            <PublicRoute path="/reset-password" exact component={ResetPassword} />

            <Menu>
            <ProtectedRoute path="/dashboard" exact component={Dashboard}/>
              
            <ProtectedRoute path="/dataroom" exact component={DataRoom} />
              
            <ProtectedRoute path="/market-insight" component={MarketInsights} exact />
              
            <ProtectedRoute path="/asset-strategy" exact component={AssetStrategy}/>

            <ProtectedRoute path="/top-7-cities" exact component={Top7Cities} />

            <ProtectedRoute path="/district-analysis" exact component={DistrictComparativeAnalysis}/>

            <ProtectedRoute path="/asset-overview" exact component={AssetOverview}/>

            <ProtectedRoute path="/asset-capital" exact component={AssetCapital}/>

            <ProtectedRoute path="/asset-overview-detail" exact component={AssetOverviewDetail}/>

            <ProtectedRoute path="/asset-report" exact component={AssetReport} />
            <ProtectedRoute path="/portfolio-reporting" component={PortfolioReporting}>
            </ProtectedRoute>
            </Menu>
            {user && user.jwt && user.user.name ?
             <Redirect from="*" to="/dashboard" />
            :
            <Redirect from="*" to="/login" />
            }
          </Switch>

      </SuspenseWithChunkError>
    </Router>
  );
}

export default App;
